import React from 'react';

import { PackageReservationActionsProps } from './types';
import { ReservationActionsRow, ReserveButton } from './styled';

const PackageReservationActions = ({
  disabled,
  loading = false,
  ctaLabel = 'Turu Seç',
  onReserve,
}: PackageReservationActionsProps) => {
  return (
    <ReservationActionsRow>
      <ReserveButton
        type='button'
        disabled={disabled}
        aria-busy={loading}
        onClick={onReserve}
      >
        {ctaLabel}
      </ReserveButton>
    </ReservationActionsRow>
  );
};

export default PackageReservationActions;
